import React from "react";

interface ColorCircleIconProps {
  theme: "colorful" | "monochrome";
  size?: number;
}

export default function ColorCircleIcon({
  theme,
  size = 20,
}: ColorCircleIconProps) {
  const colors =
    theme === "colorful"
      ? [
          "var(--chart-colorful-1)",
          "var(--chart-colorful-2)",
          "var(--chart-colorful-3)",
          "var(--chart-colorful-4)",
          "var(--chart-colorful-5)",
          "var(--chart-colorful-6)",
        ]
      : [
          "var(--chart-mono-1)",
          "var(--chart-mono-2)",
          "var(--chart-mono-3)",
          "var(--chart-mono-4)",
          "var(--chart-mono-5)",
          "var(--chart-mono-6)",
        ];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      style={{ minWidth: size, minHeight: size }}
    >
      {colors.map((color, index) => {
        const angle = (index * 60 * Math.PI) / 180;
        const nextAngle = ((index + 1) * 60 * Math.PI) / 180;

        const x1 = 50 + 50 * Math.cos(angle);
        const y1 = 50 + 50 * Math.sin(angle);
        const x2 = 50 + 50 * Math.cos(nextAngle);
        const y2 = 50 + 50 * Math.sin(nextAngle);

        return (
          <path
            key={index}
            d={`M 50 50 L ${x1} ${y1} A 50 50 0 0 1 ${x2} ${y2} Z`}
            fill={color}
          />
        );
      })}
    </svg>
  );
}
